export default __webpack_public_path__ + "locales/lv/EmbeddingPanel.json?hash=c8cbc845b864de4afea457f93961e224";